import React from "react";

function Logo(props){
    return <img src={`${process.env.PUBLIC_URL}/media/logo.png`} id="rislogo" alt={"Logo ristorante"} className={"nav-logo"}/>;
}

export default Logo;